import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { IIncomingJob } from '../interfaces/incoming-job';
import { IPageResult } from '../interfaces/page-result';
import { Injectable } from '@angular/core';
import { ISearchAtLocationParam } from '../interfaces/search-at-location-param';

@Injectable({ providedIn: 'root' })
export class SearchJobAtLocationService {
  constructor(public http: HttpClient) {}

  public getPage(searchParam: ISearchAtLocationParam): Promise<IPageResult<IIncomingJob>> {
    return this.http
      .post('/api/order/search/location/', searchParam)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public extractData(res) {
    return res;
  }

  public handleError(errorResponse: HttpErrorResponse | any) {
    let fullErrorMessage: string;
    if (errorResponse instanceof HttpErrorResponse) {
      const error = errorResponse.error || JSON.stringify(errorResponse);
      fullErrorMessage = `${errorResponse.status} - ${errorResponse.statusText || ''} ${error}`;
    } else {
      fullErrorMessage = errorResponse.message ? errorResponse.message : errorResponse.toString();
    }
    console.error(fullErrorMessage);
    return Promise.reject(fullErrorMessage);
  }
}
